import { useState } from "react";
import { REWARDS_SETUP_GUIDE } from "../../constants/rewardsSetupGuide";

const BODY_ID = "rewards-setup-guide-body";

export default function RewardsSetupGuideCard() {
  const [isOpen, setIsOpen] = useState(false);

  const handleToggle = () => {
    setIsOpen((prev) => !prev);
  };

  return (
    <div className="rounded-2xl border border-slate-200 bg-white shadow-sm p-5">
      <div className="flex items-center justify-between gap-3">
        <div className="text-base md:text-lg font-semibold text-slate-900">
          Help: Rewards Setup Guide
        </div>
        <button
          type="button"
          onClick={handleToggle}
          aria-expanded={isOpen}
          aria-controls={BODY_ID}
          className="rounded-full border border-slate-300 px-4 py-2 text-xs md:text-sm font-semibold text-slate-700 hover:bg-slate-50"
        >
          {isOpen ? "Hide Setup Guide" : "Show Setup Guide"}
        </button>
      </div>
      {!isOpen && (
        <p className="mt-2 text-sm text-slate-500">
          New to rewards? Open this guide to set up earning and redeem rules.
        </p>
      )}
      <div
        id={BODY_ID}
        hidden={!isOpen}
        aria-hidden={!isOpen}
        className="mt-4 space-y-4"
      >
        <p className="text-sm text-slate-600">{REWARDS_SETUP_GUIDE.intro}</p>
        <div className="grid gap-4 md:grid-cols-2">
          {REWARDS_SETUP_GUIDE.sections.map((section) => (
            <div key={section.heading} className="space-y-2">
              <div className="text-sm font-semibold text-slate-800">
                {section.heading}
              </div>
              <ul className="list-disc space-y-1 pl-5 text-sm text-slate-600">
                {section.bullets.map((bullet) => (
                  <li key={bullet}>{bullet}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
